export default __webpack_public_path__ + "static/media/icon_create.9add4a8a.svg";